import React from "react";
import {Swiper} from "swiper/react";

export const DefaultSlider = ({children, autoplay, ...props}) => (
    <Swiper
        loop={true}
        slidesPerView={1}
        // pagination={{clickable: true, currentClass: "pb-5"}}
        autoplay={autoplay ? {delay: 6000, disableOnInteraction: false} : false}
        {...props}
    >
        {children}
    </Swiper>
);

export default DefaultSlider;
